import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    fontFamily: 'Atkinson Hyperlegible, sans-serif',
    fontSize: 14,
    lineHeight: 1.5,
    colorPrimary: '#4f39f6',
    colorSuccess: '#00bc7d',
    colorWarning: '#ffd230',
    colorError: '#fb2c36',
    colorInfo: '#4f39f6',
    colorText: '#2c241e',
    colorTextSecondary: '#545654',
    colorTextTertiary: '#929392',
    colorBgContainer: '#f8f9f8',
    colorBgElevated: '#ffffff',
    colorBorder: '#c5c6c5',
    colorBorderSecondary: '#eaebea',
    borderRadius: 8,
    controlHeight: 40,
  },
  components: {
    Button: {
      fontWeight: 600,
      borderRadius: 6,
      controlHeight: 40,
      paddingInline: 16,
    },
    Card: {
      borderRadius: 8,
      paddingLG: 24,
    },
    Typography: {
      titleMarginBottom: 16,
      titleMarginTop: 0,
    },
  },
};